import * as React from "react";

import "./personalization.scss";

import {cs}        from "@Common/react/chain-services";
import {isDevQuan} from "@Common/ui-components/debug/is-dev-quan";

import {groupEnrollmentEditors} from "../../common/group-enrollment-editors";

import {Headshot}    from "./headshot/headshot";
import {Information} from "./information/information";

export const Personalization = ({initEnrollment, program, agentId, editionList, qrCode, next}) => cs(
    ["information", (_, next) => Information({initEnrollment, program, agentId, next})],
    ["headshot", (_, next) => Headshot({initEnrollment, program, agentId, next})],
    ({information, headshot}) => next({
        enrollmentEditor: groupEnrollmentEditors([
            information.enrollmentEditor,
            headshot.enrollmentEditor,
            qrCode.enrollmentEditor,
        ]),
        render: ({showErrors}) => (
            <div className="personalization-4eu">
                <div className="left">
                    {information.render({})}

                    {!headshot.disabled && <>
                        <div className="spacer" style={{"--bottom": "16px"} as any}/>
                        {headshot.render({
                            imageName: program.programPreferences.imageName || "Headshot",
                            showErrors,
                        })}
                    </>}

                    <div className="spacer" style={{"--bottom": "16px"} as any}/>
                    {qrCode.render({showErrors})}
                </div>
                <div className="right">
                    {editionList.render({})}
                </div>
            </div>
        ),
    }),
);
